import useStyles from "../assets/styles/useStyles";
import logo from "../assets/logo.png";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Copyright from "../components/Copyright";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import usePOST from "../hooks/usePOST";
import {withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

function ResetPassword() {
    const {token} = useParams();
    const [responsePost, sendPostRequest] = usePOST();
    const [tokenRequest, sendTokenRequest] = usePOST();
    const [error, setError] = useState({password: false});
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [passwordChanged, setPasswordChanged] = useState(false);

    const navigate = useNavigate();
    const classes = useStyles();

    // vérifier une seule fois la validité du token
    useEffect(() => {
        sendTokenRequest({
            id: "checkToken",
            url: `/api/users/checkResetPasswordToken`,
            data: { token },
            headers: {},
        });
    }, [sendTokenRequest, token]);

    useEffect(() => {
        const response = tokenRequest["checkToken"];

        if (token === "")
            navigate("/signIn");

        if (!response) return;

        try {
            if (response.status < 200 || response.status >= 300) {
                console.log("Invalid token");
                navigate("/signIn");
            }
        } catch (err) {
            console.log("Invalid token");
            navigate("/signIn");
        }
    }, [tokenRequest, navigate, token]);



    const submitHandler = async (event) => {
        event.preventDefault();

        let passMatchErr = document.getElementById("passwords-match-error");
        passMatchErr.style.display = "none";

        if (passwordConfirm !== password) {
            setError({password: true});
            passMatchErr.style.display = "block"
            return;
        }

        await sendPostRequest({
            id: 'resetPass',
            url: `/api/users/resetPassword`,
            data: {
                token: token,
                password: password,
            },
            headers: {},
        });
    };

    useEffect(() => {
        const response = responsePost["resetPass"];
        if (!response) return;

        try {
            if (response.status >= 200 && response.status < 300) {
                setPasswordChanged(true)
            } else {
                document.getElementById("pass-error").style.display = "block";
                setError({password: true});
            }
        } catch (err) {
            console.log("error while changing pass:", err);
            navigate("/signIn");
        }
    }, [responsePost, navigate]);

    return <div>
        <img src={logo} alt="Logo" style={{width: 100}}/>
        <Grid container className={classes.root}>
        {passwordChanged && <div className={classes.paper}>
            <Box mb={3}>
                <Typography variant="h1" align="center"><b>MOT DE PASSE CHANGÉ</b></Typography>
                <br></br>
                <Typography id="password-changed" className={classes.confirm} align="center">
                    Votre mot de passe a bien été changé, merci de retourner à la page de connexion.
                </Typography>

                <div style={{ textAlign: "center", marginTop: "8px" }}>
                    <Button
                        onClick={() => (
                            navigate('/signIn', { replace: true })
                        )}
                        size="small"
                        className={classes.submit}
                    >
                        Retourner à la page de connexion
                    </Button>
                </div>
            </Box>
        </div>}
        {!passwordChanged && <div className={classes.paper}>
                <Box mb={3}>
                    <Typography variant="h1" align="center"><b>MOT DE PASSE OUBLIÉ</b></Typography>
                </Box>
                <form onSubmit={submitHandler} className={classes.form}>
                    <Typography id="pass-error" className={classes.message} align="center">
                        Erreur lors du changement de mot de passe, merci de contacter un administrateur.
                    </Typography>

                    <Typography id="passwords-match-error" className={classes.message} align="center">
                        Les mots de passe ne correspondent pas.
                    </Typography>

                    <CssTextField
                        label="Mot de passe"
                        variant="outlined"
                        required
                        error={error.password}
                        fullWidth
                        margin="normal"
                        type="password"
                        onChange={(event) => {
                            setPassword(event.target.value)
                        }}
                        inputProps={{
                            minLength: 8,
                        }}
                        helperText="Longueur min: 8 caractères"
                    />

                    <CssTextField
                        label="Confirmation du mot de passe"
                        variant="outlined"
                        required
                        error={error.password}
                        fullWidth
                        margin="normal"
                        type="password"
                        onChange={(event) => {
                            setPasswordConfirm(event.target.value)
                        }}
                    />
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center",}}>
                        <Button type="submit" variant="contained" className={classes.submit}>
                            CHANGER DE MOT DE PASSE
                        </Button>
                    </div>
                </form>
                <Box mt={5}>
                    <Copyright/>
                </Box>
            </div>}
        </Grid>
    </div>
}

const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#FF9300',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FF9300',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: "20px",
            '& fieldset': {
                borderColor: '#FF9300',
            },
            '&:hover fieldset': {
                borderColor: '#FF9300',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9300',
            },
        },

    },
})(TextField);

export default ResetPassword;